import { render, staticRenderFns } from "./viewFeeConfigData.vue?vue&type=template&id=5ac596eb"
import script from "./viewFeeConfigData.vue?vue&type=script&lang=js"
export * from "./viewFeeConfigData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports